/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEnrichedInstrumentLinksApp} from '../api'

 export const useQueryGetEnrichedInstrumentLinksApp = createReactQueryHook('getEnrichedInstrumentLinksApp', getEnrichedInstrumentLinksApp)
